import { Flex, Select } from "@theorgchartdev/storybook";
import { RuleCriteriaTypeMapping } from "./ViewRuleEditor.utils";
import { RuleInput } from "../../Composites/RuleInput/RuleInput";
import { QChartTemplateRule } from "@coreapp/CoreApp/QChartTemplateRule";

export const ViewRuleEditorFilter = props => {
  const handleSetCriteriaType = ({ value }) => {
    const rule = props.rule.Clone();
    rule.SetRuleCriteria(value);
    props.setRule(rule);
  };

  return (
    <Flex direction="column" gap="16px">
      <Select
        listWidth="fill"
        listProps={{
          optionSize: "small"
        }}
        dataTestId="view-rule-editor-criteria-type"
        value={props.rule.GetRuleCriteriaType()}
        options={BuildCriteriaTypeOptions(handleSetCriteriaType)}
      />
      {props.rule.GetRuleCriteriaType() !== RuleCriteriaTypeMapping.Always && (
        <RuleInput
          basicRuleInputProps={{
            requiredMarker: true,
            rulePairProps: { showFieldComparisons: true }
          }}
          editing
          rule={props.rule}
          setRule={props.setRule}
          errorsObject={props.errorsObject}
        />
      )}
    </Flex>
  );
};

const BuildCriteriaTypeOptions = onCriteriaSelect => {
  let ruleTypeList = [
    RuleCriteriaTypeMapping.Always,
    RuleCriteriaTypeMapping.Basic,
    RuleCriteriaTypeMapping.Complex
  ];
  let options = [];
  for (let ruleType of ruleTypeList) {
    let option = {};
    option.clickHandler = onCriteriaSelect;
    option.label = ruleType;
    option.value = ruleType;
    option.dataTestId = "rule-criteria-type-" + ruleType;
    //option.eventInfo = value;
    options.push(option);
  }
  return options;
};
